import DateTimeService from '@/shared/services/dateTime';
import { BusinessHoursOption } from './businessHoursOption';

export const hasOverlappingOpenClose = (current: BusinessHoursOption, comparison: BusinessHoursOption): boolean => {
	return isSameDay(current, comparison) && current.open !== comparison.open;
};

export const isSameDay = (current: BusinessHoursOption, comparison: BusinessHoursOption): boolean => {
	return current.day.name === comparison.day.name;
};

export const hasOverlappingHours = (current: BusinessHoursOption, comparison: BusinessHoursOption): boolean => {
	const currentStartTime = DateTimeService.getMinutes(current.startTime) as number;
	const currentEndTime = DateTimeService.getMinutes(current.endTime) as number;
	const comparisonStartTime = DateTimeService.getMinutes(comparison.startTime) as number;
	const comparisonEndTime = DateTimeService.getMinutes(comparison.endTime) as number;
	return (
		(currentStartTime <= comparisonEndTime && currentStartTime >= comparisonStartTime) ||
		(comparisonStartTime <= currentEndTime && comparisonStartTime >= currentStartTime)
	);
};


export const hasAtLeastOneOnlineTime = (businessHours: BusinessHoursOption[]): boolean => {
	if (!businessHours) { return false; }

	const nonHolidayHours = businessHours.filter(b => !b.day.holidayId);
	if (!nonHolidayHours || nonHolidayHours.length === 0) {
		return false;
	}

	for (const businessHour of nonHolidayHours) {
		if (businessHour.open) {
			return true;
		}
	}
	return false;
};
